import { GoSearch } from "react-icons/go";

import './styles.scss'

export function Home() {
    return (
        <div className="contentContainer">
            <div className="guideToUseOn">
                <div className="guideContainer">
                    <GoSearch />
                    <h2>Bem vindo ao Guia de Referências do SISTEMA MECAUTO!</h2>
                    <h2>Utilize o MENU à esquerda ou a barra de pesquisa acima para localizar informações.</h2>
                </div>
            </div>
        </div>
    )
}